import { AlertService } from './../../service/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ProdutosService } from 'src/app/service/produtos.service';
import { Produtos } from 'src/app/model/produtos.model';

@Component({
  selector: 'app-atualizar-produto',
  templateUrl: './atualizar-produto.component.html',
  styleUrls: ['./atualizar-produto.component.css']
})
export class AtualizarProdutoComponent implements OnInit {

  constructor(private router: Router, 
    private service: ProdutosService, 
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
  ) { }

  produto: Produtos = {
    vc_nome: '',
    bl_status: false
  }

  ngOnInit(): void {
    this.produto.sr_id = this.activatedRoute.snapshot.paramMap.get('sr_id')!;
    this.listarPorId();
  }

  listarPorId(): void {
    this.service.listarIdService(this.produto.sr_id).subscribe(resp => {
      this.produto = resp
    })
  }

  atualizar():void {
    this.service.atualizarService(this.produto).subscribe(resp => {
      this.alertService.success()
      this.router.navigate(['configuracao/produtos'])
    })
  }

  cancel(){
    this.router.navigate(['configuracao/produtos']);
  }

}
